import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';

export const baseURI = '/catalogos/tipos-de-referencias-de-pagos/';

/**
 * GET  Tipo de Referencia de Pago
 * @returns {Promise<Array<object>>}
 */
export const getTiposDeReferenciaDePagos = async (params = null) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Tipo de Referencia de Pago
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getTipoDeReferenciaDePago = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return response.data;
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST Tipo de Referencia de Pago
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postTipoDeRefrenciaDePago = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Tipo de Referencia de Pago
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchTipoDeRefrenciaDePago = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Tipo de Referencia de Pago
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteTipoDeRefrenciaDePago = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
